module.exports = __webpack_public_path__ + "static/media/clipPath.16143cfe.svg";